import { render, staticRenderFns } from "./DataArticle2.vue?vue&type=template&id=8cbe9908&"
import script from "./DataArticle2.vue?vue&type=script&lang=js&"
export * from "./DataArticle2.vue?vue&type=script&lang=js&"
import style0 from "./DataArticle2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports